import { Selection as JsonSelection, useCreateRevision } from 'hooks/queries/layers/revisions/useCreateRevision'
import { useAlmanacEditorState } from 'stores/EditorState'
import { markdownSerializer } from 'common/Prose/components/TextInlineFormatBar/components/FormatBars/markdownSerializer'
import { RevisionType } from 'components/BlazeCommandLine/Types'
import { AllSelection, TextSelection } from 'prosemirror-state'

interface Props {
  articleId: string
  layerId: string
}

export const useImproveQuality = ({ articleId, layerId }: Props) => {
  const editorState = useAlmanacEditorState()

  const { mutate, ...rest } = useCreateRevision(
    { articleKey: articleId, layerId },
    {
      onSuccess: () => {
        if (!editorState) return

        const tr = editorState.view.state.tr
        tr.setSelection(TextSelection.create(editorState.view.state.doc, 0))
        editorState.view.dispatch(tr)
      },
    },
  )

  const improveQuality = () => {
    if (!editorState) return

    const doc = editorState.view.state.doc

    let proseSelection = editorState?.selection || new AllSelection(editorState.view.state.doc)
    if (proseSelection.empty) proseSelection = new AllSelection(editorState.view.state.doc)
    const documentAsMarkdown = markdownSerializer.serialize(doc)
    const selectionContent = doc.cut(proseSelection.from, proseSelection.to)
    const selectionAsMarkdown = markdownSerializer.serialize(selectionContent)

    mutate({
      prompt: {
        custom_prompt:
          'Improve the quality of the writing in this document while maintaining the original language variation (e.g., British or American English) if detectable.',
        revision_type: RevisionType.CUSTOM_PROMPT,
      },
      selection: proseSelection.toJSON() as JsonSelection,
      selectionAsMarkdown,
      documentAsMarkdown,
    })
  }

  return {
    improveQuality,
    ...rest,
  }
}
